import {useOutletContext} from 'react-router-dom';
import styles from './AiHelpDesk.module.scss';
import {TicketsTable} from './components/TicketsTable';
import {TicketCard} from './components/TicketCard';
import {TicketCardSkeleton} from './components/TicketCardSkeleton';
import {TicketsChatView} from './components/TicketsChatView';

export const ResolvedTickets = () => {
  const {
    viewMode,
    tickets,
    ticketsLoading,
    currentPage,
    pageSize,
    totalTickets,
    onPageChange,
    refetchTickets,
    chatTickets,
    chatHasMore,
    chatLoadingMore,
    onChatLoadMore,
  } = useOutletContext();

  const renderContent = () => {
    if (viewMode === 'chat') {
      return (
        <TicketsChatView
          tickets={chatTickets}
          loading={ticketsLoading && chatTickets.length === 0}
          emptyMessage="No resolved tickets."
          hasMore={chatHasMore}
          loadingMore={chatLoadingMore}
          onLoadMore={onChatLoadMore}
        />
      );
    }

    if (viewMode === 'list') {
      return (
        <TicketsTable
          tickets={tickets}
          loading={ticketsLoading}
          currentPage={currentPage}
          pageSize={pageSize}
          total={totalTickets}
          onPageChange={onPageChange}
          onChanged={refetchTickets}
        />
      );
    }

    if (ticketsLoading) {
      return (
        <div className={styles.gridView}>
          {[...Array(6)].map((_, i) => (
            <TicketCardSkeleton key={i} />
          ))}
        </div>
      );
    }

    if (tickets.length === 0) {
      return (
        <div style={{textAlign: 'center', padding: '48px', color: '#64748b'}}>
          No resolved tickets.
        </div>
      );
    }

    return (
      <div className={styles.gridView}>
        {tickets.map(ticket => (
          <TicketCard
            key={ticket.id}
            ticket={ticket}
            onChanged={refetchTickets}
          />
        ))}
      </div>
    );
  };

  return <div className={styles.tabContent}>{renderContent()}</div>;
};
